import React, { useEffect, useRef, useState } from 'react';
import getCaretCoordinates from 'textarea-caret';
import {
  TESTCOLOR_CANDIDATE,
  TESTCOLOR_ACTIVE,
} from '../../../../constants/colors.js';

const className = 'npm__react-simple-code-editor__textarea';

const cssText = /* CSS */ `
/**
 * Reset the text fill color so that placeholder is visible
 */
.${className}:empty {
  -webkit-text-fill-color: inherit !important;
}
/**
 * Hack to apply on some CSS on IE10 and IE11
 */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /**
    * IE doesn't support '-webkit-text-fill-color'
    * So we use 'color: transparent' to make the text transparent on IE
    * Unlike other browsers, it doesn't affect caret color in IE
    */
  .${className} {
    color: transparent !important;
  }
  .${className}::selection {
    background-color: #accef7 !important;
    color: transparent !important;
  }
}
`;

const style = {
  fontFamily: '"Fira code", "Fira Mono", monospace',
  fontSize: 12,
};

const createMarker = (icon) => {
  // create a marker for the input
  const marker = document.createElement('Button');
  marker.classList.add('icon');
  marker.innerHTML = `<img src='./${icon}' alt='test' width="10" height="10"  />`;
  return marker;
};

const CodingEditor = ({
  highlight,
  testState,
  value,
  onValueChange,
  setTestState,
  solve,
  onKeyDown,
}) => {
  const padding = 10;
  const contentStyle = {
    paddingTop: padding,
    paddingRight: padding,
    paddingBottom: padding,
    paddingLeft: padding,
  };
  const [testCandidate, setTestCandidate] = useState(undefined);

  const ref = useRef(null);
  const input = ref.current;

  const processClick = (evt, i) => {
    var element = document.getElementById(`addmarker${i}`);
    if (element !== null) {
      element.parentNode.removeChild(element);
    }

    let newTest = JSON.parse(JSON.stringify(testState));
    newTest.splice(i, 1);
    setTestState({
      test: newTest,
    });
  };

  const addTestCandidate = (evt) => {
    let overlap = false;
    for (let i = 0; i < testState.length; i++) {
      if (
        testState[i].start[0] <= testCandidate.start[0] &&
        testCandidate.start[0] < testState[i].end[0]
      ) {
        overlap = true;
      }
      if (
        testState[i].start[0] < testCandidate.end[0] &&
        testCandidate.end[0] < testState[i].end[0]
      ) {
        overlap = true;
      }
      if (
        testState[i].start[0] >= testCandidate.start[0] &&
        testCandidate.end[0] > testState[i].start[0]
      ) {
        overlap = true;
      }
      if (
        testState[i].end[0] >= testCandidate.start[0] &&
        testCandidate.end[0] > testState[i].end[0]
      ) {
        overlap = true;
      }
    }
    if (overlap) {
      console.log('overlap');
      return;
    }

    let newTest = JSON.parse(JSON.stringify(testState));
    newTest.push(testCandidate);
    newTest.sort((a, b) => a.start[0] - b.start[0]);
    setTestState({
      test: newTest,
    });
    setTestCandidate(undefined);
  };

  useEffect(() => {
    if (input && !solve) {
      for (let i = 0; i < testState.length + 1; i++) {
        var element = document.getElementById(`marker${i}`);
        if (element !== null) {
          element.parentNode.removeChild(element);
        }
      }

      for (let i = 0; i < testState.length; i++) {
        if (testState[i] === undefined) {
          continue;
        }

        var caret = getCaretCoordinates(input, testState[i].end[0]);
        const x = caret.left;
        const y = caret.top;
        const newLeft = x - 5;
        const newTop = y - 10;

        let marker = createMarker('minusicon.svg');
        marker.setAttribute('id', `marker${i}`);
        const textarea = document.getElementById('textareaid');
        textarea.appendChild(marker);
        marker.setAttribute(
          'style',
          `left: ${newLeft}px; z-index: 300000; top: ${newTop}px; position:absolute; background-color: transparent; border: 0px solid transparent;
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
    padding: 0;
    margin: 0;
    outline: none;
    `,
        );

        marker.addEventListener('click', (event) => processClick(event, i));
      }

      var element = document.getElementById(`addmarker${0}`);
      if (element !== null) {
        element.parentNode.removeChild(element);
      }

      if (testCandidate !== undefined) {
        var caret = getCaretCoordinates(input, testCandidate.end[0]);
        const x = caret.left;
        const y = caret.top;
        const newLeft = x - 5;
        const newTop = y - 10;

        let marker = createMarker('plusicon.svg');
        marker.setAttribute('id', `addmarker${0}`);
        const textarea = document.getElementById('textareaid');
        textarea.appendChild(marker);
        marker.setAttribute(
          'style',
          `left: ${newLeft}px; z-index: 300000; top: ${newTop}px; position:absolute; background-color: transparent; border: 0px solid transparent;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  padding: 0;
  margin: 0;
  outline: none;
  `,
        );
        marker.addEventListener('click', addTestCandidate);
      }
    }
    if (input !== null && solve && testState.length !== 0) {
      input.focus();
      input.setSelectionRange(testState[0].start, testState[0].start);
    }
  }, [testState, testCandidate, input]);

  var highlighted = highlight(value);

  let markArray = [];

  testState.map((test) =>
    markArray.push({
      start: test.start,
      end: test.end,
      color: TESTCOLOR_ACTIVE,
    }),
  );
  if (testCandidate !== undefined) {
    markArray.push({
      start: testCandidate.start,
      end: testCandidate.end,
      color: TESTCOLOR_CANDIDATE,
    });
  }

  for (let k = 0; k < markArray.length; k++) {
    var separators = [
      '(</span>)',
      '(<span class=.*?>)',
      `(<marked style="background-color:${TESTCOLOR_ACTIVE}">)`,
      `(<marked style="background-color:${TESTCOLOR_CANDIDATE}">)`,
      '(</marked>)',
    ];

    var splitted = highlighted.split(new RegExp(separators.join('|'), 'g'));
    var i = 0;
    while (i < splitted.length) {
      if (splitted[i] === undefined) {
        splitted.splice(i, 1);
      } else {
        i = i + 1;
      }
    }
    // console.log(markArray[k]);
    // console.log(markArray[k].start);
    let startPos = markArray[k].start[0];
    let endPos = markArray[k].end[0];
    i = 0;
    let counter = 0;

    while (i < splitted.length) {
      let length = splitted[i].length;
      length =
        length -
        (splitted[i].match(/&lt;/g) || []).length * 3 -
        (splitted[i].match(/&amp;/g) || []).length * 4;

      if (counter <= endPos) {
        if (counter + length > endPos) {
          splitted[i] =
            splitted[i].substring(0, endPos - counter) +
            '</marked>' +
            splitted[i].substring(endPos - counter);
        } else if (counter + length > startPos) {
          splitted[i] = splitted[i] + '</marked>';
        }
      }

      if (counter + length > startPos) {
        if (counter <= startPos) {
          splitted[i] =
            splitted[i].substring(0, startPos - counter) +
            `<marked style="background-color:${markArray[k].color}">` +
            splitted[i].substring(startPos - counter);
        }
        if (counter > startPos && counter <= endPos) {
          splitted[i] =
            splitted[i].substring(0, 0) +
            `<marked style="background-color:${markArray[k].color}">` +
            splitted[i].substring(0);
        }
      }

      counter = counter + length;
      i = i + 2;
    }
    let merged = splitted.join('');
    highlighted = merged;
  }

  // console.log(highlighted);

  const getValue = () => {
    return value;
  };

  const handleChange = (e) => {
    const oldValue = getValue();
    const { value, selectionStart, selectionEnd } = e.target;

    if (solve) {
      for (let i = 0; i < testState.length; i++) {
        const startOffi = testState[i].start[0];
        const endOffi = oldValue.length - testState[i].end[0];
        if (
          value.substring(0, startOffi) === oldValue.substring(0, startOffi) &&
          value.substring(value.length - endOffi, value.length) ===
            oldValue.substring(oldValue.length - endOffi, oldValue.length)
        ) {
          testState[i].end[0] = value.length - endOffi;
          let diff = value.length - oldValue.length;
          for (let j = i + 1; j < testState.length; j++) {
            testState[j].start[0] += diff;
            testState[j].end[0] += diff;
          }
          onValueChange(value);
        }
      }
    } else {
      onValueChange(value);
    }
  };

  const handleSelected = (e) => {
    const { value, selectionStart, selectionEnd } = e.target;
    if (selectionStart < selectionEnd && !solve) {
      setTestCandidate({
        start: [selectionStart],
        end: [selectionEnd],
        together: false,
      });
    }
  };

  return (
    <div style={{ ...styles.container, ...style }} id="textareaid">
      <textarea
        ref={ref}
        style={{
          ...styles.editor,
          ...styles.textarea,
          ...contentStyle,
        }}
        value={value}
        onChange={handleChange}
        onSelect={handleSelected}
        onKeyDown={onKeyDown}
        autoFocus
      />
      <pre
        aria-hidden="true"
        style={{ ...styles.editor, ...styles.highlight, ...contentStyle }}
        {...(typeof highlighted === 'string'
          ? { dangerouslySetInnerHTML: { __html: highlighted + '<br />' } }
          : { children: highlighted })}
      />
      <style type="text/css" dangerouslySetInnerHTML={{ __html: cssText }} />
    </div>
  );
};

export default CodingEditor;

const styles = {
  container: {
    position: 'relative',
    textAlign: 'left',
    boxSizing: 'border-box',
    padding: 0,
    overflow: 'hidden',
  },
  textarea: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    resize: 'none',
    color: 'inherit',
    overflow: 'hidden',
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
    WebkitTextFillColor: 'transparent',
  },
  highlight: {
    position: 'relative',
    pointerEvents: 'none',
  },
  editor: {
    margin: 0,
    border: 0,
    background: 'none',
    boxSizing: 'inherit',
    display: 'inherit',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'inherit',
    fontVariantLigatures: 'inherit',
    fontWeight: 'inherit',
    letterSpacing: 'inherit',
    lineHeight: 'inherit',
    tabSize: 'inherit',
    textIndent: 'inherit',
    textRendering: 'inherit',
    textTransform: 'inherit',
    whiteSpace: 'pre-wrap',
    wordBreak: 'keep-all',
    overflowWrap: 'break-word',
  },
};
